// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"13492a22","277":"4d16a647","527":"117f9980","684":"6e5962fe","836":"13492a22","854":"13492a22","861":"13492a22"}[chunkId] + ".chunk.css";
};